document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('RBServiceIntake');
  if (!form || form.dataset.rbStructured === 'true') return;
  form.dataset.rbStructured = 'true';

  form.addEventListener('submit', function () {
    var preserve = new Set([
      'contact[Service]',
      'contact[Name]',
      'contact[email]',
      'contact[Phone]'
    ]);

    var serviceInput = form.querySelector('[name="contact[Service]"]');
    var service = serviceInput ? serviceInput.value.trim() : 'Service Request';
    var fields = Array.prototype.slice.call(form.querySelectorAll('[name^="contact["]')).filter(function (field) {
      return field.name !== 'contact[body]' && !preserve.has(field.name);
    });

    function labelFromName(name) {
      var match = name.match(/^contact\[(.*)\]$/);
      return match ? match[1] : name;
    }

    function fieldValue(field) {
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return '';
      return (field.value || '').trim();
    }

    var preferenceFields = [];
    var detailFields = [];
    var availabilityFields = [];

    fields.forEach(function (field) {
      var label = labelFromName(field.name);
      var item = { label: label, value: fieldValue(field) || '—' };
      if (label === 'Preferred contact method') {
        preferenceFields.push(item);
      } else if (label === 'Preferred days and times' || label === 'Additional notes') {
        availabilityFields.push(item);
      } else {
        detailFields.push(item);
      }
    });

    var lines = [
      'ROCKAWAY BOTANICA SERVICE REQUEST',
      '',
      'SERVICE',
      service
    ];

    if (preferenceFields.length) {
      lines.push('', 'CONTACT PREFERENCE');
      preferenceFields.forEach(function (item) {
        lines.push(item.label + ':', item.value, '');
      });
    }

    if (detailFields.length) {
      lines.push(service.toUpperCase() + ' DETAILS');
      detailFields.forEach(function (item) {
        lines.push(item.label + ':', item.value, '');
      });
    }

    if (availabilityFields.length) {
      lines.push('AVAILABILITY & NOTES');
      availabilityFields.forEach(function (item) {
        lines.push(item.label + ':', item.value, '');
      });
    }

    var body = form.querySelector('textarea[name="contact[body]"]');
    if (!body) {
      body = document.createElement('textarea');
      body.name = 'contact[body]';
      body.hidden = true;
      form.appendChild(body);
    }
    body.value = lines.join('\n').trim();

    fields.forEach(function (field) {
      field.removeAttribute('name');
    });
  });
});
